<script lang="ts">
    import { onMount } from 'svelte';
    import PageHeader from '../components/PageHeader.svelte';
    import TileEnterprise from '../components/TileEnterprise.svelte';
    import { getEnterprises } from '../scripts/apiEnterprises';
    import { storeEnterprises, storeEnterprisesError } from "../scripts/enterprise";
    import { addNotificationError }  from "../scripts/toaster";
    import { storeLanguage, lang_fr, storeLoader } from "../scripts/store";
    import { launchLoader, stopLoader } from "../scripts/utils";

    onMount(async () => {
        getEnterprisesIfEmpty();
        window.scrollTo(0,0);
	});

    /**
     * getEnterprisesIfEmpty
     */
    function getEnterprisesIfEmpty() {
        if ($storeEnterprises.length <= 0) {
            launchLoader();
            const returnValue = getEnterprises();
            returnValue.then((data) => {
                stopLoader();
                if (!data) {
                    addNotificationError($storeEnterprisesError);
                };
            });
        }
    }

</script>
    
<style lang="scss">

    .nosentreprises {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        width: 100%;
        &__bloc {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
        }
        &__tiles {
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            flex-wrap: wrap;
            align-items: center;
            margin: 0 32px 0 32px;
        }
    }

    @include large {
        .nosentreprises {
            &__tiles {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                flex-wrap: wrap;
            }
        }
    }

</style>

<div class="nosentreprises">
    {#if ($storeLanguage == $lang_fr)}
    <PageHeader props="nos entreprises membres"/>
    {:else}
    <PageHeader props="our companies"/>
    {/if}
    <div class="bloc nosentreprises__bloc">
        <div class="nosentreprises__tiles">
            {#if ($storeEnterprisesError != "")}
            <div class="getallarticles__article getallarticles__error">
                <p>Error : {$storeEnterprisesError}</p>
            </div>
        {:else}
            {#each $storeEnterprises as enterprise}
            {#if (enterprise.id != 99 && enterprise.member == 1)}
            <TileEnterprise props={enterprise}/>
            {/if}
            {/each}
        {/if}
        </div>    
    </div>
</div>
